module.exports = __webpack_public_path__ + "static/media/play-button-over.9ed9a871.svg";